export { default } from "./RetailerDetailsModal";
